"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = _interopRequireWildcard(require("react-emotion"));

var _emotionTheming = require("emotion-theming");

var styles = function styles(_ref) {
  var color = _ref.theme.color;
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;top:0;left:0;right:0;bottom:0;transform-origin:left;border-top:4px solid ", color.accent, ";background-image:linear-gradient(to right,", color.white, ",", color.accentHighlight, ");transition:transform 1s linear;")
  );
};

var _default = (0, _emotionTheming.withTheme)(
/*#__PURE__*/
(0, _reactEmotion.default)("div", {
  target: "css-73y7nw0"
})(styles));

exports.default = _default;